<template>
  <nav class="navbar navbar-inverse navbar-fixed-top" role="navigation">
    <div class="container">
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#navbar-collapse">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
          <!-- <a class="navbar-brand" href="/commencement/live/">CSUB Commencement</a> -->
      </div>
      <div class="collapse navbar-collapse" id="navbar-collapse">
        <ul class="nav navbar-nav text-center">
          <!--li><a href="static/documents/event-program.pdf">Event Program</a></li-->
          <!-- <li><a href="/commencement/live/">Commencement Live</a></li> -->
          <li><a href="/">CSUB Home</a></li>
          <li><a href="/commencement/">Commencement Home</a></li>
        </ul>
      </div>
    </div>
</nav>
</template>

<script>
export default {
  data () {
    return { }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /* Center navbar links */
  .navbar-nav {
    float: none;
    margin: 0 auto;
    display: table;
    table-layout: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue